export { default } from './NewsDialog';
